module.exports = __webpack_public_path__ + "img/einstieg_in_reifentechnik_und_montage_784x514.4dfa21c8.jpg";